import type { IncomingHttpHeaders } from 'http';
import { Dispatch } from 'redux';

import { getDeviceInformation } from 'utils/device';

export const FETCH_OS_DATA = 'FETCH_OS_DATA';
export const FETCH_OS_DATA_SUCCESS = 'FETCH_OS_DATA_SUCCESS';
export const FETCH_OS_DATA_FAILURE = 'FETCH_OS_DATA_FAILURE';

export const fetchOSData = (headers: IncomingHttpHeaders) => (dispatch: Dispatch) => {
  dispatch({
    type: FETCH_OS_DATA,
  });
  const device = getDeviceInformation(headers);
  if (device.os.name !== null) {
    const osData = { osName: device.os.name };
    dispatch({
      type: FETCH_OS_DATA_SUCCESS,
      osData,
    });
  } else {
    dispatch({
      type: FETCH_OS_DATA_FAILURE,
      error: 'Error fetching OS data',
    });
  }
};
